import axiosInstance from "@/composables/axios-instance";
import { toast } from "vue3-toastify";

const state = {
  types: [],
  reportsList: [],
};

const getters = {
  getTypesList(state) {
    return state.types;
  },
  getReportsList(state) {
    return state.reportsList;
  },
};

const mutations = {
  setTypesList(state, list) {
    state.types = list;
  },
  setReportsList(state, list) {
    state.reportsList = list;
  },
};

const actions = {
  getTypesListFromApi({ commit }) {
    return axiosInstance
      .get("/report/type/get/")
      .then((response) => {
        commit("setTypesList", response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  /* eslint-disable */
  createReport({}, report) {
    let data = {};
    for (let key in report) {
      if (report[key]) data[key] = report[key];
    }
    return axiosInstance.postForm("/report/create/", data).then(() => {
      toast.success("گزارش با موفقیت ارسال شد.");
    });
  },

  getReportsListFromApi({ commit }) {
    return axiosInstance
      .get("/report/get/")
      .then((response) => {
        commit("setReportsList", response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },

  getMyReportsListFromApi({ commit }) {
    return axiosInstance
      .get("/report/get/my/")
      .then((response) => {
        commit("setReportsList", response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },

  updateReport({}, report) {
    return axiosInstance
      .putForm(
        "/report/update/",
        report,
        { params: { report_id: report.id } }
      )
      .then(() => {
        toast.success("گزارش با موفقیت بایگانی شد.");
      })
      .catch((error) => {
        toast.error("متاسفانه گزارش بایگانی نشد لطفا بعدا تلاش کنید");
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
